import { render } from "./RetencionList.vue?vue&type=template&id=7a1a093e&scoped=true"
import script from "./RetencionList.vue?vue&type=script&lang=js"
export * from "./RetencionList.vue?vue&type=script&lang=js"

import "./RetencionList.vue?vue&type=style&index=0&id=7a1a093e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1a093e"]])

export default __exports__